import MenuItem from 'material-ui/MenuItem';
import SelectField from 'material-ui/SelectField';
import React from 'react';
import BooleanRadioButtons from '../components/BooleanRadioButtons';
import Card from '../components/card';
import { LoanCard } from './card-lenses';

const visas = {
  H1B: 'H-1B',
  L1: 'L-1',
  O1: 'O-1',
  J1: 'J-1',
  TN: 'TN',
  other: 'Other'
};

const Visa = ({ model, onChange, ...cardProps }) => (
  <Card title="What type of visa do you hold?" {...cardProps}>
    <SelectField
      style={{ maxWidth: 320, width: '100%' }}
      maxHeight={300}
      labelStyle={{ paddingLeft: 0 }}
      underlineStyle={{ margin: '-1px 24px -1px 0' }}
      value={model.get('visa')}
      floatingLabelText={model.get('visa') == null ? 'Select one' : ''}
      onChange={(event, _, payload) => {
        onChange('visa', payload);
      }}
    >
      {Object.keys(visas).map((visa, v) => (
        <MenuItem key={v} value={visa} primaryText={visas[visa]} />
      ))}
    </SelectField>
    <br />
    <br />
    <p>Is your visa valid for the next 12 months?</p>
    <BooleanRadioButtons
      name="visaValid"
      value={model.get('visaValid')}
      onChange={onChange.bind(null, 'visaValid')}
    />
  </Card>
);

Visa.id = 'Visa';

Visa.completed = ({ model }) => model.get('visa') != null && model.get('visaValid') != null;

export default LoanCard(Visa);



// WEBPACK FOOTER //
// ./src/cards/visa.js